import * as React from "react";
import "./ImageTheme.css";

interface ImageBasedThemeProps {
    image: string;
    verticalOrientation: boolean;
};

const ImageBasedTheme: React.FC<ImageBasedThemeProps> = ({
    image,
    verticalOrientation
}) => {

    return (
        <div
          style={{
            backgroundImage: `url(${image})`,
            backgroundSize: "100% 100%",
            backgroundRepeat: "no-repeat",
            backgroundPosition: "left top",
            height: verticalOrientation === true ? "100vw" : "100vh",
            width: verticalOrientation === true ? "100vh" : "100%",
          }}
        ></div>
    );
};

export default ImageBasedTheme;